module.exports = new __parcel__URL__("confluence-availability-hero.783f42a0.gif").toString();